// skipcq: JS-W1028
import { useEffect, useState } from 'react';
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../utils/firebase';
import { SPLAT_AWARD_REPORTS_COLLECTION } from '../utils/firestoreCollections';
import { buildSplatAwardMonthlyTableRows } from '../utils/splatAwardMonthlyReport';

const MONTHLY_REPORT_LOOKBACK_COUNT = 24;

function useSplatAwardMonthlyReports() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        if (!cancelled) {
          setLoading(true);
          setError(null);
        }

        const reportsCollection = collection(db, SPLAT_AWARD_REPORTS_COLLECTION);
        const reportsQuery = query(
          reportsCollection,
          where('type', '==', 'monthly'),
          orderBy('date', 'desc'),
          limit(MONTHLY_REPORT_LOOKBACK_COUNT),
        );
        const snapshot = await getDocs(reportsQuery);
        if (cancelled) return;

        const documents = snapshot.docs.map((documentSnap) => {
          const data = documentSnap.data();
          return {
            id: documentSnap.id,
            date: typeof data.date === 'string' ? data.date : '',
            metrics:
              typeof data.metrics === 'object' && data.metrics !== null ? data.metrics : {},
          };
        });
        setRows(buildSplatAwardMonthlyTableRows(documents));
      } catch (fetchError) {
        console.error('useSplatAwardMonthlyReports fetch error', fetchError);
        if (!cancelled) {
          setError('Failed to load monthly splat awards');
          setRows([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, []);

  return { rows, loading, error };
}

export default useSplatAwardMonthlyReports;
